import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment.prod'

import { catchError } from 'rxjs/operators';

import { AuthService } from '../shared/guards/auth.service';


import { Observable, of } from 'rxjs';

import moment from 'moment-timezone';
// import { Observable } from 'rxjs/dist/types/internal/Observable';
// import { of } from 'rxjs/dist/types/internal/Observable/of';



const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'timezoneInt': ((new Date().getTimezoneOffset() / 60) * -1).toString(),
        "location": moment.tz.guess(),
    })
};

@Injectable({
    providedIn: 'root'
})
export class AccountService {

    Token: string;
    userId: string;
    private apiurl = environment.apiurl;

    constructor(
        private http: HttpClient,
        private authService: AuthService) {
        this.Token = this.authService.getToken();
        this.userId = this.authService.getUserId();
    }

    UserLogin(loginModel: any): Observable<any> {
        return this.http.post<any>(this.apiurl + "Account/UserLogin", loginModel, httpOptions)
            .pipe(

            );
    }

    ChangePassword(m: any): Observable<any> {
        return this.http.post<any>(this.apiurl + "Account/ChangePassword", m, httpOptions)
            .pipe(

            );
    }

    Get2FA(model: any): Observable<any> {
        return this.http.post<any>(this.apiurl + "Account/Gen2FA", model, httpOptions)
            .pipe(
                //catchError(this.handleError<UserModel>())
            );
    }

    Gen2FAByPassPassword(model: any): Observable<any> {
        return this.http.post<any>(this.apiurl + "Account/Gen2FAByPassPassword", model, httpOptions)
            .pipe(
                //catchError(this.handleError<UserModel>())
            );
    }

    SendChangePasswordEmail(model: any): Observable<any> {
        return this.http.post<any>(this.apiurl + "Account/SendChangePasswordEmail", model, httpOptions)
            .pipe(
                //catchError(this.handleError<UserModel>())
            );
    }

    CheckStatus(): Observable<any> {
        this.Token = this.authService.getToken();
        this.userId = this.authService.getUserId();
        httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this.Token);
        httpOptions.headers = httpOptions.headers.set('UserId', this.userId);
        return this.http.get<any>(this.apiurl + "Account/CheckStatus", httpOptions)
            .pipe(
                //catchError(this.handleError<UserModel>())
            );
    }

    // GetStaffList(model: any): Observable<any> {
    //     this.Token = this.authService.getToken();
    //     this.userId = this.authService.getUserId();
    //     httpOptions.headers = httpOptions.headers.set('Authorization', 'Bearer ' + this.Token);
    //     httpOptions.headers = httpOptions.headers.set('UserId', this.userId);
    //     model = new Object();
    //     model.IsDelete = false;
    //     return this.http.post<any>(this.apiurl + "Account/GetStaffList", model, httpOptions)
    //         .pipe(
    //             //catchError(this.handleError<BookingModel>())
    //         );
    // }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }
}
